import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Container,
    Typography,
} from "@mui/material";
import React from "react";
import Link from "@mui/material/Link";
import { Helmet } from "react-helmet-async";
import pie from "../assets/pie_image.jpg";
import security from "../assets/security_image.png";
export default function AboutPage() {
    return (
        <>
            <Helmet>
                <title>WealthWatch | About</title>
            </Helmet>
            <Container
                sx={{
                    my: 2,
                    "@media (max-width: 75em)": {
                        width: "80%",
                    },
                }}
            >
                <Box color={"primary.contrastText"}>
                    <Typography variant="h3">
                        About Wealth
                        <span style={{ color: "rgba(0,255,149,1)" }}>
                            Watch
                        </span>
                    </Typography>
                    <br></br>
                    <Typography sx={{ marginBottom: 5, marginTop: 1 }}>
                        WealthWatch is a goated application where you can read a
                        variety of your financial services in one application.
                        This includes services related to stocks, crypto and
                        bank accounts. It is a read only application, which
                        means that the application does not modify or manipulate
                        any of the services. Such as buying a stock or
                        transfering money. It just reads the services
                        information. Such as balance, portfolio data etc .
                        <br></br>
                        <br></br>
                        After obtaining the relevant information of each of the
                        services, WealthWatch displays it in a dashboard style,
                        where you can get an overview of all services together
                        as well as a more detailed overview of the specific
                        services.
                    </Typography>
                    <img
                        src={pie}
                        style={{ width: "50%", borderRadius: 5 }}
                    ></img>
                    <Typography sx={{ my: 2 }}>
                        This means that the you are able to quckly view all your
                        financial services in one location, instead of having to
                        manually log in to each service and record each
                        service's information. This can be helpful for a variety
                        of reasons such as for taxes, future financial planning
                        or just to keep up to date with you current financial
                        situation.
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{ my: 1 }}
                        color={"rgba(0,255,149,1)"}
                    >
                        Security
                    </Typography>
                    <img
                        src={security}
                        style={{ width: "50%", borderRadius: 5 }}
                    ></img>
                    <Typography sx={{ my: 2 }}>
                        WealthWatch uses an encrypted database to store your
                        service/s login information as well as your WealthWatch
                        login information. We also uses standard password
                        hashing, with an optional email you can add for account
                        recovery. The website also uses an SSL connection to
                        ensure encrypted traffic between client and host
                    </Typography>
                    <Typography variant="h5" color="rgba(0,255,149,1)">
                        How exactly does this work?
                    </Typography>
                    <Typography sx={{ my: 1 }}>
                        Click on each tab to see what the process along with
                        what information is required from each service.
                    </Typography>
                </Box>
                <Accordion
                    sx={{
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                    }}
                >
                    <AccordionSummary>
                        <Typography>Selfwealth</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "primary.dark" }}>
                        <Typography>
                            For Selfwealth we require your Selfwealth account
                            login information. Since Selfwealth does not have
                            any sort of public API that we can use. We instead
                            take your login details in which the program will
                            login as you. Once logged in we use the session
                            information to create API request to get the
                            infromation that we need. This is different to
                            scraping where information is taken from the
                            websites HTML. We are getting the account
                            information through the API. The routes which we
                            find out throught reverse engineering (simply
                            finding what requests gets called and what
                            information each of them have).
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    sx={{
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                    }}
                >
                    <AccordionSummary>
                        <Typography>Swyftx</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "primary.dark" }}>
                        <Typography>
                            For Swyftx we your accounts API key. Swyftx is the
                            easiest and quickest. Swyftx has a public API where
                            you can get information for your account. You need
                            to generate and API key which is what links the API
                            requests to your account and is used as part of the
                            authentication process. You can learn to generate an
                            API key{" "}
                            <Link
                                color={"#0288d1"}
                                href="https://support.swyftx.com/hc/en-au/articles/14254548716185-Create-an-API-Key"
                                target="_blank"
                            >
                                here.{" "}
                            </Link>
                            We then use this API key to get the information
                            related to your account.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion
                    sx={{
                        backgroundColor: "primary.main",
                        color: "primary.contrastText",
                    }}
                >
                    <AccordionSummary>
                        <Typography>Commbank</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "primary.dark" }}>
                        <Typography>
                            For Commbank we require your Nebank account login
                            information. Commbank will require your netbank ID
                            and password since there is no public API that we
                            can access. We instead take your login details in
                            which the program will login as you. Once logged in
                            we use the session information to create API request
                            to get the infromation that we need. This is
                            different to scraping where information is taken
                            from the websites HTML. We are getting the account
                            information through the API. The routes which we
                            find out throught reverse engineering (simply
                            finding what requests gets called and what
                            information each of them have).
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </>
    );
}
